import { render, staticRenderFns } from "./TsFilterChip.vue?vue&type=template&id=735cb9e6"
import script from "./TsFilterChip.vue?vue&type=script&lang=ts"
export * from "./TsFilterChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports